import React, { useContext, useMemo } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';

import ChatContext from 'components/chat/ChatContext';
import InsertInvitationIcon from 'components/icons/Calendar';
import EmailIcon from 'components/icons/EmailSmall';
import ChatroomIcon from 'components/icons/Chatroom';
import { APP, RONGCLOUD_CHATROOM_PREFIX, BRAND_COLOR } from 'appenv';

const Container = styled.div`
  height: 120px;
  display: flex;
  flex-direction: column;
  padding: 16px;
  text-align: center;
`;

const TitleContainer = styled.div`
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 16px;
`;

const BtnGroupContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
`;

const StyledHyperLink = styled.a`
  text-decoration: none;
  color: ${BRAND_COLOR || '#0CA58B'};

  &:visited {
    color: ${BRAND_COLOR || '#0CA58B'};
  }
`;

const BtnContainer = styled.div`
  cursor: pointer;
  color: ${BRAND_COLOR || '#0CA58B'} !important;

  & svg {
    fill: ${BRAND_COLOR || '#0CA58B'};
  }
`;

const BusinessPopover = ({
  boothId,
  boothName,
  emailContacts,
  meetupUrl,
}) => {
  const { showChatWindow } = useContext(ChatContext);

  const mailToLink = useMemo(() => {
    if (emailContacts && emailContacts.length > 0) {
      const email = emailContacts.find((eachemailContact) => (eachemailContact.type === 'email'));
      if (email?.contact) {
        return `mailto:${email.contact}`;
      }
    }
    return '';
  }, [emailContacts]);

  const openChatWindow = () => {
    window.trackingEvent('OpenChatWindow', 'BusinessPopover', boothId);
    showChatWindow(`${RONGCLOUD_CHATROOM_PREFIX}_booth_${boothId}`, 'group', boothName);
  };

  const clickMeetup = () => {
    window.trackingEvent('Meetup', 'BusinessPopover', boothId);
  };

  const clickLeaveMessage = () => {
    window.trackingEvent('Leave a Message', 'BusinessPopover', boothId);
  };

  return (
    <Paper elevation={3}>
      <Container>
        <TitleContainer>
          Hi, how can I help you?
        </TitleContainer>
        <BtnGroupContainer>
          {
            APP !== 'paloalto623' && (
              <BtnContainer onClick={openChatWindow}>
                <ChatroomIcon width={24} height={22} color={BRAND_COLOR} />
                <div>
                  {
                    APP === 'hkstp608' ? 'Public Chat' : 'Chat'
                  }
                </div>
              </BtnContainer>
            )
          }
          {
            mailToLink && (
              <StyledHyperLink href={mailToLink} target="_blank" rel="noopener noreferrer">
                <BtnContainer onClick={clickLeaveMessage}>
                  <EmailIcon width={24} height={22} color={BRAND_COLOR || '#0CA58B'} />
                  <div>Leave a Message</div>
                </BtnContainer>
              </StyledHyperLink>
            )
          }
          {
            meetupUrl && (
              <StyledHyperLink href={meetupUrl} target="_blank" rel="noopener noreferrer">
                <BtnContainer onClick={clickMeetup}>
                  <InsertInvitationIcon width={24} height={22} color={BRAND_COLOR || '#0CA58B'} />
                  <div>Meetup</div>
                </BtnContainer>
              </StyledHyperLink>
            )
          }
        </BtnGroupContainer>
      </Container>
    </Paper>
  );
};

BusinessPopover.propTypes = {
  boothId: PropTypes.number.isRequired,
  boothName: PropTypes.string.isRequired,
  emailContacts: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  meetupUrl: PropTypes.string,
};

BusinessPopover.defaultProps = {
  meetupUrl: '',
};

export default BusinessPopover;
